var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmongUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_397",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29217",
    "data-name": "Group 29217",
    transform: "translate(657 10118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29043",
    "data-name": "Group 29043",
    transform: "translate(-4329 -5317)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3672, -4801)",
    filter: "url(#Ellipse_397)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397-2",
    "data-name": "Ellipse 397",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-among-us",
    transform: "translate(3689 -4787.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8466",
    "data-name": "Rectangle 8466",
    width: 27,
    height: 27,
    transform: "translate(6 6.265)",
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50742",
    "data-name": "Path 50742",
    d: "M31.956,34.4H11.394A25.532,25.532,0,0,1,11,29.855V21.524s1.091-5.6,2.439-7.263a7.62,7.62,0,0,1,5.135-3.34c2.272-.53,5.4-.174,6.816.757,1.628,1.075,2.552,5.052,2.886,8.55,1.128-.227,3.946.151,4.165.969C33.637,25.53,32.569,31.6,31.956,34.4Z",
    transform: "translate(-1.213 -1.134)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50743",
    "data-name": "Path 50743",
    d: "M32.342,34.793H11.871c-.167-2.022-.364-5.339-.371-9.634.629,3.166,1.234,7.263,5.286,7.414,2.636.091,6.263.417,7.445-1.856a25.269,25.269,0,0,0,2.658-11.83c-.144-4.423-1.325-6.21-1.613-6.589.447.5,2.832,3.4,3.037,8.861.023.629.045,1.3.061,2.015,3.188-.114,4.491,1.136,4.6,1.78A24.929,24.929,0,0,1,32.342,34.793Z",
    transform: "translate(-1.335 -1.529)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50744",
    "data-name": "Path 50744",
    d: "M28.934,23c0,2.779-.212,8.482-.318,11.232H27.1c.106-2.711.318-8.46.318-11.232,0-4.2-1.106-9.58-2.689-10.618-1.25-.818-4.158-1.121-6.233-.644a6.8,6.8,0,0,0-4.65,2.969l-.061.076c-.992,1.212-1.962,5.241-2.272,6.786v8.179a23.306,23.306,0,0,0,.409,4.484H10.379A25.72,25.72,0,0,1,10,29.751l.015-8.4c.114-.583,1.174-5.779,2.6-7.528l.061-.068a8.262,8.262,0,0,1,5.491-3.491c2.484-.576,5.809-.189,7.4.856C28.017,12.726,28.934,19.262,28.934,23Z",
    transform: "translate(-0.971 -0.97)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50745",
    "data-name": "Path 50745",
    d: "M15.2,17.282c3.951-.042,7.112.214,6.816,4.552s-6.421,4.19-7.112,4.042-5.927-.033-5.829-4.042S12.536,17.31,15.2,17.282Z",
    transform: "translate(-0.746 -2.737)",
    fill: "#01579b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50746",
    "data-name": "Path 50746",
    d: "M38.973,33.512a12.1,12.1,0,0,1-.924,3.5h-1.84c.189-.144.856-.841,1.265-3.711.432-3.029-.174-8.929-.7-9.679a8.49,8.49,0,0,0-3.31-.674l.076-1.507c.788.038,3.431.235,4.324,1.128C38.935,23.651,39.389,30.6,38.973,33.512Z",
    transform: "translate(-6.663 -3.746)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50747",
    "data-name": "Path 50747",
    d: "M10.154,19.5c.2,1.559-.148,2.538,1.926,2.686s6.116.774,7.121-.42,1.325-3.306-.675-3.989C17.108,17.292,12.278,16.508,10.154,19.5Z",
    transform: "translate(-1.008 -2.744)",
    fill: "#81d4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50748",
    "data-name": "Path 50748",
    d: "M15.3,26.349a4.44,4.44,0,0,1-.8-.052c-.065-.014-.179-.027-.329-.045-4.047-.514-6.1-2.108-6.1-4.737,0-2.043.886-5.482,6.806-5.544l.137,0c2.608-.029,4.858-.052,6.265,1.377a5.509,5.509,0,0,1,1.247,4.188,4.1,4.1,0,0,1-1.624,3.194A9.743,9.743,0,0,1,15.3,26.349Zm-.4-8.864c-5.306.056-5.308,3.047-5.308,4.03,0,2.355,2.725,2.973,4.775,3.234.207.027.364.048.455.067.426.076,3.544.027,5.192-1.312a2.545,2.545,0,0,0,1-2.009,4.147,4.147,0,0,0-.813-3.086c-.956-.97-2.9-.95-5.169-.925Z",
    transform: "translate(-0.504 -2.417)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50749",
    "data-name": "Path 50749",
    d: "M14.411,18.991c1.482-.247,3.879-.4,3.359.988-.37.988-5.442,1.655-5.442.494S14.411,18.991,14.411,18.991Z",
    transform: "translate(-1.535 -3.113)",
    fill: "#e1f5fe"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmongUs);
export default __webpack_public_path__ + "static/media/amongUs.fd693db61cac4acf1351583aedc40ff6.svg";
export { ForwardRef as ReactComponent };